import React from 'react';
import { useTranslation } from 'react-i18next';

import scss from './ThirdPartyRightsBadge.module.scss';

function ThirdPartyRightsBadge({ thirdPartyRights }) {
  const { t } = useTranslation('activ8');

  if (!thirdPartyRights) {
    return null;
  }

  return <span className={scss.badge}>{t('thirdPartyRights')}</span>;
}

export default ThirdPartyRightsBadge;
